import React from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from '../pages/home/HomePage';
import CompanyPage from '../pages/company/CompanyPage';
import SolutionPage from '../pages/solution/SolutionPage';
import ProductsPage from '../pages/products/ProductsPage';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import ScrollTop from '../utils/ScrollTop';

export default function route() {
    return (
        <BrowserRouter>
            <ScrollTop />
            <Header />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/company" element={<CompanyPage />} />
                <Route path="/solution" element={<SolutionPage />} />
                <Route path="/products" element={<ProductsPage />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    )
}
